<template>
    <van-popup v-model:show="show" position="bottom" @opened="handleOpened" @closed="handleClosed" :style="{
        minWidth: '100%',
        minHeight: '45%',
        zIndex: '10002'
    }">
        <div class="pop_container">
            <div style="padding: 5px 20px;">
                <van-tabs class="regLoginTab" v-model:active="active" @change="changeTab" line-width="30%"
                    title-inactive-color="#ffffff80" title-active-color="#fff">
                    <van-tab :title-style="{ fontSize: '18px' }" v-for="(tab, index) in tabList" :key="index"
                        :title="tab.title" :name="tab.index">
                    </van-tab>
                </van-tabs>
            </div>
            <div class="register_container">

                <div class="form_container">

                    <!-- phone number field -->
                    <InputField v-model="phoneNumber" :isShowError="dataSet?.phoneValidationNotice"
                        @valueChanged="phoneNumberChange" :labelText="$t('profile.phoneNum')" :isshowFlag="true"
                        fieldType="number" />
                    <div>
                        <div v-if="dataSet?.phoneValidationNotice" class="errorNotice">
                            {{ $t('loginRegister.phoneFormat') }}
                        </div>
                    </div>

                    <!-- password fields -->
                    <InputField v-model="password" :isShowError="dataSet?.passwordValidationNotice"
                        @valueChanged="passwordChange" :isPassword="true" :labelText="$t('loginRegister.enterPassword')"
                        fieldType="password" />
                    <div v-if="dataSet?.passwordValidationNotice" class="errorNotice">
                        {{ $t('loginRegister.passwordForamt') }}
                    </div>
                    <InputField v-if="dataSet?.signType == 0" v-model="confirmPassword"
                        :isShowError="dataSet?.confirmPasswordValidationNotice || (dataSet?.password !== '' && dataSet?.confirmPassword !== '' && dataSet?.password !== dataSet?.confirmPassword)"
                        @valueChanged="confirmPasswordChange" :isPassword="true"
                        :labelText="$t('loginRegister.confirmPassword')" fieldType="password" />
                    <div v-if="dataSet?.confirmPasswordValidationNotice" class="errorNotice">
                        {{ $t('loginRegister.passwordForamt') }}
                    </div>
                    <div v-else-if="dataSet?.confirmPassword && dataSet?.password && dataSet?.confirmPassword !== dataSet?.password"
                        class="errorNotice">
                        {{ $t('loginRegister.differentPassword') }}
                    </div>

                    <!-- Captcha field -->
                    <CaptchaField v-if="dataSet?.isShowCaptcha" v-model="captcha" :captcha-img="dataSet?.captchaImg"
                        @valueChanged="captchaChage" @updateCaptcha="getCaptchaImageData"
                        :labelText="$t('loginRegister.captchaEnter')" />
                    <div v-if="dataSet?.signType == 0">
                        <!-- whatsapp OTP -->
                        <InputField v-if="dataSet?.showSMSOTP" v-model="smsOTP" @valueChanged="smsOTPChange"
                            ref="smsOTPRef" :labelText="$t('loginRegister.smsCode')" fieldType="number" :isOTP="true"
                            @getOtp="getSMSOTP" />
                        <!-- Whatsapp OTP -->
                        <InputField v-if="dataSet?.showWhatsappOTP" v-model="whatsappOTP"
                            @valueChanged="whatsappOTPChange" ref="whatsappOTPRef"
                            :labelText="$t('loginRegister.whatsappCode')" fieldType="number" :isOTP="true"
                            @getOtp="getWhatsappOTP" />
                        <!-- email OTP-->
                        <div v-if="dataSet?.showEmailOTP">
                            <InputField v-model="emailOTP" :isShowError="dataSet?.emailValidationNotice"
                                @valueChanged="emailChange" :labelText="$t('loginRegister.enteremail')"
                                fieldType="email" />
                            <div>
                                <div v-if="dataSet?.emailValidationNotice" class="errorNotice">
                                    {{ $t('loginRegister.emailFormat') }}
                                </div>
                            </div>

                            <InputField v-model="email" @valueChanged="emailOTPChange" ref="emailOTPRef"
                                :labelText="$t('loginRegister.emailCode')" fieldType="number" :isOTP="true"
                                @getOtp="getEmailOTP" />
                        </div>
                    </div>



                    <div class="human_verify" v-if="dataSet?.cloudFlareCaptchaEnabled && dataSet?.signType == 0">
                        <div ref="turnstileContainer"></div>
                    </div>

                    <div class="btn_container">
                        <MainButton v-if="dataSet?.signType == 0" :title="$t('common.register')"
                            :activeStatus="dataSet?.isRegisterBtnActive" @click="signUp" />
                        <MainButton v-if="dataSet?.signType == 1" :title="$t('common.login')"
                            :activeStatus="dataSet?.isLoginBtnActive" @click="signIn(false)" />
                    </div>
                    <p class="bottomText">{{ $t('loginRegister.regConfirm') }}</p>

                </div>

            </div>
        </div>
        <SliderCaptcha v-model="showSliderCaptcha" @success="handleCaptchaSuccess" />
    </van-popup>
</template>

<script setup lang="ts">
import { ref, computed, nextTick, watch } from 'vue';
import InputField from './components/inputField.vue';
import CaptchaField from './components/captchaField.vue';
import { RegisterLoginData, startCountdown, stopLoading } from '@/view/loginRegister/supportScript';
import MainButton from '../components/common/mainButton.vue';
import SliderCaptcha from '@/themes/themeOne/components/sliderCaptcha.vue';
import { useI18n } from 'vue-i18n';


const { t } = useI18n()

// Macros are auto-imported in <script setup>, but if explicitly imported, ensure consistent usage.
// To fix "emits not defined", we'll move the definition to the top.

const props = defineProps<{
    dataSet: RegisterLoginData
}>()

const emits = defineEmits(['open', 'close', 'changeSignType', 'phoneNumberChange', 'smsOTPChange', 'whatsappOTPChange', 'emailChange', 'emailOTPChange', 'passwordChange', 'confirmPasswordChange', 'captchaChage', 'signIn', 'signUp', 'getCaptchaImageData', 'getSMSOTP', 'getWhatsappOTP', 'getEmailOTP', 'turnstileTokenChange', 'turnstile-error'])

const emailOTPRef = ref()
const smsOTPRef = ref()
const whatsappOTPRef = ref()
const turnstileContainer = ref()
const turnstileWidgetId = ref('')
const turnstileRetryCount = ref(0)
const showSliderCaptcha = ref(false)
const currentAction = ref<'signIn' | 'signUp'>('signUp')

const show = ref(props.dataSet.show)
const phoneNumber = ref(props.dataSet.phoneNumber)
const email = ref(props.dataSet.email)
const password = ref(props.dataSet.password)
const confirmPassword = ref(props.dataSet.confirmPassword)
const smsOTP = ref(props.dataSet.smsOTP)
const whatsappOTP = ref(props.dataSet.whatsappOTP)
const emailOTP = ref(props.dataSet.emailOTP)
const captcha = ref(props.dataSet.captcha)
const active = computed(() => props.dataSet.signType)
const tabList = ref([
    { index: 1, title: t('common.login') },
    { index: 0, title: t('common.register') }
])

const open = (type: number) => {
    emits('open', type)
}

const renderTurnstile = () => {
    nextTick(() => {
        if (turnstileContainer.value && !turnstileWidgetId.value && (window as any).turnstile) {
            try {
                turnstileWidgetId.value = (window as any).turnstile.render(turnstileContainer.value, {
                    sitekey: props.dataSet.cloudFlareSiteKey,
                    theme: 'dark',
                    retry: 'never',
                    callback: (token: string) => {
                        emits('turnstileTokenChange', token)
                    },
                    'error-callback': () => {
                        emits('turnstile-error', 'error');
                        if (turnstileRetryCount.value < 3) {
                            turnstileRetryCount.value++;
                            if (turnstileWidgetId.value) (window as any).turnstile.reset(turnstileWidgetId.value);
                        }
                    },
                    'expired-callback': () => {
                        emits('turnstileTokenChange', '');
                    }
                });
            } catch (e) {
                console.error('Turnstile render error:', e);
            }
        }
    })
}

const removeTurnstile = () => {
    if (turnstileWidgetId.value && (window as any).turnstile) {
        try {
            (window as any).turnstile.remove(turnstileWidgetId.value);
        } catch (e) {
            console.error('Turnstile remove error:', e);
        }
        turnstileWidgetId.value = '';
        emits('turnstileTokenChange', '');
    }
}

const resetTurnstile = () => {
    if (turnstileWidgetId.value && (window as any).turnstile) {
        try {
            (window as any).turnstile.reset(turnstileWidgetId.value);
        } catch (e) {
            console.error('Turnstile reset error:', e);
        }
        emits('turnstileTokenChange', '');
    }
}

const handleOpened = () => {
    if (props.dataSet.cloudFlareCaptchaEnabled && props.dataSet.signType == 0) {
        renderTurnstile()
    }
}

const handleClosed = () => {
    turnstileRetryCount.value = 0;
    removeTurnstile()
}

watch(() => props.dataSet.cloudFlareCaptchaEnabled, (newVal) => {
    if (newVal && props.dataSet.signType == 0) {
        renderTurnstile()
    } else {
        removeTurnstile()
    }
})

watch(() => props.dataSet.signType, (newVal) => {
    if (props.dataSet.cloudFlareCaptchaEnabled) {
        if (newVal == 0) {
            renderTurnstile()
        } else {
            removeTurnstile()
        }
    }
})

const close = () => {
    emits('close')
}

const changeTab = (index: number) => {
    // active.value = index
    changeSignType(index)

}
const changeSignType = (value: number) => {
    emits('changeSignType', value)
}

const phoneNumberChange = (value: string) => {
    emits('phoneNumberChange', value)
}
const smsOTPChange = (value: string) => {
    emits('smsOTPChange', value)
}
const whatsappOTPChange = (value: string) => {
    emits('whatsappOTPChange', value)
}
const emailChange = (value: string) => {
    emits('emailChange', value)
}

const emailOTPChange = (value: string) => {
    emits('emailOTPChange', value)
}

const passwordChange = (value: string) => {
    emits('passwordChange', value)
}

const confirmPasswordChange = (value: string) => {
    emits('confirmPasswordChange', value)
}
const captchaChage = (value: string) => {
    emits('captchaChage', value)
}
const signIn = (isReg: boolean) => {
    emits('signIn', isReg)
}
const signUp = () => {
    if (props.dataSet.sliderEnabled) {
        currentAction.value = 'signUp';
        showSliderCaptcha.value = true;
    } else {
        emits('signUp');
    }
}

const handleCaptchaSuccess = (data: any) => {
    if (currentAction.value === 'signUp') {
        emits('signUp', data);
    } else {
        emits('signIn', false, data);
    }
}

const getCaptchaImageData = () => {
    emits('getCaptchaImageData')
}


const getSMSOTP = () => {
    emits('getSMSOTP')

}

const getWhatsappOTP = () => {
    emits('getWhatsappOTP')

}

const getEmailOTP = () => {
    emits('getEmailOTP')
}

const handleStartCountdown = (type: 'sms' | 'whatsapp' | 'email') => {
    startCountdown({ sms: smsOTPRef, whatsapp: whatsappOTPRef, email: emailOTPRef }, type)
}

const handleStopLoading = (type: 'sms' | 'whatsapp' | 'email') => {
    stopLoading({ sms: smsOTPRef, whatsapp: whatsappOTPRef, email: emailOTPRef }, type)
}
watch(() => props.dataSet, (newDataSet) => {
    phoneNumber.value = newDataSet.phoneNumber;
    email.value = newDataSet.email;
    password.value = newDataSet.password;
    confirmPassword.value = newDataSet.confirmPassword;
    smsOTP.value = newDataSet.smsOTP;
    whatsappOTP.value = newDataSet.whatsappOTP;
    emailOTP.value = newDataSet.emailOTP;
    captcha.value = newDataSet.captcha;
}, { deep: true });
defineExpose({
    handleStartCountdown,
    handleStopLoading,
    resetTurnstile
})
</script>
<style scoped>
.van-popup {
    background: linear-gradient(rgb(159, 51, 132), rgb(62, 45, 76));
    background-size: cover;
    background-repeat: no-repeat;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: auto;
    width: 100%;
    border-radius: 18px 18px 0 0;
}

.regLoginTab {
    position: relative;

}

.regLoginTab ::v-deep .van-tab {
    border-bottom: 3.5px solid #f6a5d4;
}

.regLoginTab ::v-deep .van-tab--active ::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fff;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}

.regLoginTab ::v-deep .van-tabs__nav--line {
    background: transparent;
    color: #fff;
}

.regLoginTab ::v-deep .van-tabs__line {
    background: #fff;
    /* background: #f6a5d4; */
}

.regLoginTab ::v-deep .van-tab--active {
    font-weight: 400;
    /* background: #f6a5d4; */
}

.register_container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 30vh;
    padding: 3% 0;
}

.form_container {
    /* background-image: linear-gradient(180deg, rgba(136, 90, 41, 0.50) 0%, rgba(40, 18, 3, 0.50) 100%);
    box-shadow: inset 0px -2px 0px 0px rgba(225, 146, 90, 1), inset 0px 2px 0px 0px rgba(225, 146, 90, 1); */
    backdrop-filter: blur(4px) !important;
    /* margin: 30% 0 0; */
    border-radius: 20px;
    padding: 0px 0px 20px 0px;
    width: 90%;
}

.close_icon {
    display: flex;
    justify-content: right;
    padding: 20px 15px;
}

.close_icon img {
    width: 18px;
    padding: 2.5px;
    background: rgba(0, 0, 0, 0.25);
    border-radius: 30px;
}

.main_title {
    font-weight: bold;
    font-size: 35px;
    color: #FFFFFF;
    padding: 15px 0;
}

.content_text {
    font-weight: 600;
    font-size: 13px;
    color: #FFFFFF;
    padding: 0 0 15px;
}

.content_text span {
    color: #FF780D;
}

.human_verify {
    margin: 10px 0 0;
    display: flex;
    justify-content: center;
    min-height: 43.32px;
    align-items: center;
}

.errorNotice {
    color: #E00000;
    font-size: 13px;
    font-weight: bold;
    padding: 0 10px;
}

.btn_container {
    padding-top: 41.472px;
}

.checkBoxContainer {
    padding: 10px 10px 0;
}

.checkBoxContainer>>>.van-checkbox__label {
    color: #fff;
    padding: 5px;
}

.checkBoxContainer>>>.van-checkbox__icon--checked .van-icon {
    background-color: #FF780D !important;
    border-color: #FF780D !important;

}

.bottomText {
    color: #c18bb1;
    font-weight: 800;
    text-align: center;
    padding: 0px 10px;
}
</style>